module.exports = __webpack_public_path__ + "img/d22.0e8a016c.png";